export default "__VITE_ASSET__ded651ab__"